
import { Component, HostListener, OnInit, OnDestroy, Input, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LiveTestExecutorComponent } from 'src/app/modules/live-test-executor/live-test-executor.component';
import { ScenarioService } from 'src/app/modules/scenario/services/scenario.service';
import { StepsService } from 'src/app/modules/steps/services/steps.service';
import { ToastService } from 'src/app/toast/toast.service';
import { ExecutionResultService } from 'src/app/services/execution-result.service';
import { StepPlaceholderService } from 'src/app/services/step-placeholder.service';
import { AiStepGeneratorService } from 'src/app/services/ai-step-generator.service';
import { ElementCaptureViewModel } from '../viewmodels/element-capture-viewmodel';
import { ElementCaptureService } from '../services/element-capture.service';

@Component({
    selector: 'element-capture',
    imports: [FormsModule, CommonModule, ButtonModule, AccordionModule, LiveTestExecutorComponent, HttpClientModule],
    templateUrl: './element-capture.component.html',
    styleUrls: ['./element-capture.component.css']
})
export class ElementCaptureComponent implements OnInit, OnDestroy {
  private http = inject(HttpClient);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private elementCaptureService = inject(ElementCaptureService);
  private scenarioService = inject(ScenarioService);
  private stepsService = inject(StepsService);
  private toastService = inject(ToastService);
  private executionResultService = inject(ExecutionResultService);
  private stepPlaceholderService = inject(StepPlaceholderService);
  private aiStepGenerator = inject(AiStepGeneratorService);

  public viewModel!: ElementCaptureViewModel;

  @Input() featureId: string = '';
  @Input() functionalAreaId: string = '';
  @Input() scenarioId: string = '';
  @Input() testSteps: string = '';

  @ViewChild(LiveTestExecutorComponent) liveTestExecutor!: LiveTestExecutorComponent;

  async ngOnInit() {
    this.viewModel = new ElementCaptureViewModel(
      this.http,
      this.router,
      this.route,
      this.elementCaptureService,
      this.scenarioService,
      this.stepsService,
      this.toastService,
      this.executionResultService,
      this.stepPlaceholderService,
      this.aiStepGenerator
    );

    // Wait for ViewChild to be ready
    setTimeout(() => {
      this.viewModel.init(this.liveTestExecutor);
    }, 0);
  }

  ngOnDestroy() {
    this.viewModel?.destroy();
  }

  // Delegate UI interactions to ViewModel
  startDrag(evt: MouseEvent) { this.viewModel.startDrag(evt); }
  
  @HostListener('window:mousemove', ['$event'])
  onMove(evt: MouseEvent) { this.viewModel.onMove(evt); }
  
  @HostListener('window:mouseup') 
  onUp() { this.viewModel.onUp(); }
  
  go() { this.viewModel.go(); }
  back() { this.viewModel.back(); }
  forward() { this.viewModel.forward(); }
  reload() { this.viewModel.reload(); }
  devtools() { this.viewModel.devtools(); }
  extract() { this.viewModel.extract(); }
  cancel() { this.viewModel.cancel(); }

  // Delegate business logic to ViewModel
  async saveStepScenario() { await this.viewModel.saveStepScenario(); }
  async getScenarioDetail() { await this.viewModel.getScenarioDetail(); }
  getTestSteps() { this.viewModel.getTestSteps(); }
  
  // Step generation
  async generateTestSteps() { await this.viewModel.generateTestSteps(); }
  addStepToScenario(step: any) { this.viewModel.addStepToScenario(step); }
  hasAddedSteps(): boolean { return this.viewModel.hasAddedSteps(); }
  getActionSteps() { return this.viewModel.getActionSteps(); }
  getVerificationSteps() { return this.viewModel.getVerificationSteps(); }

  // AI generation
  async generateWithAI() { await this.viewModel.generateWithAI(); }
  addAIStepToScenario(step: string, index: number) { this.viewModel.addAIStepToScenario(step, index); }
  addAllAISteps() { this.viewModel.addAllAISteps(); }
  clearAISteps() { this.viewModel.clearAISteps(); }
}
